import { ModelBase } from '../abstract/model-base.model';
import { Profile } from './profile.model';

export class ClientProfileMfa extends ModelBase {

    static override CLASS_NAME: string = 'ClientProfileMfa';

    private _profile!: Profile;
    private _requiresMfa!: boolean;

    public get profile(): Profile {
        return this._profile;
    }

    public set profile(value: any) {
        this._setValue('_profile', value, 'Profile');
    }

    public get requiresMfa(): boolean {
        return this._requiresMfa;
    }

    public set requiresMfa(value: any) {
        this._setValue('_requiresMfa', value, 'boolean');
    }
}
